<a
  [href]="href"
  [attr.aria-label]="label || icon"
  target="_blank"
  rel="noopener noreferrer"
  class="inline-flex items-center gap-2 rounded-xl border border-white/10 bg-white/5 p-2.5 text-ink-300 transition hover:border-brand-400/40 hover:text-brand-300"
>
  @switch (icon) {
    @case ('github') {
      <svg class="h-5 w-5" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
        <path
          d="M12 2C6.477 2 2 6.584 2 12.217c0 4.506 2.865 8.33 6.839 9.68.5.094.683-.22.683-.486 0-.24-.009-.875-.014-1.717-2.782.616-3.37-1.366-3.37-1.366-.454-1.175-1.11-1.488-1.11-1.488-.908-.635.069-.622.069-.622 1.004.072 1.532 1.05 1.532 1.05.892 1.56 2.341 1.11 2.91.849.09-.66.35-1.11.636-1.366-2.22-.258-4.555-1.135-4.555-5.05 0-1.115.39-2.027 1.03-2.742-.103-.258-.447-1.298.098-2.704 0 0 .84-.274 2.75 1.046A9.35 9.35 0 0112 6.844c.85.004 1.705.117 2.504.343 1.909-1.32 2.747-1.046 2.747-1.046.547 1.406.203 2.446.1 2.704.64.715 1.028 1.627 1.028 2.742 0 3.925-2.339 4.788-4.566 5.043.359.316.679.94.679 1.895 0 1.368-.012 2.471-.012 2.807 0 .269.18.586.688.486A10.22 10.22 0 0022 12.217C22 6.584 17.523 2 12 2z"
        />
      </svg>
    }
    @case ('linkedin') {
      <svg class="h-5 w-5" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
        <path
          d="M19 3A2 2 0 0121 5v14a2 2 0 01-2 2H5a2 2 0 01-2-2V5a2 2 0 012-2h14zM8.34 18.34V10.5H5.67v7.84h2.67zM7 9.3a1.55 1.55 0 110-3.1 1.55 1.55 0 010 3.1zM18.34 18.34v-4.28c0-2.29-1.22-3.35-2.85-3.35-1.31 0-1.9.72-2.23 1.23v-1.06H10.6c.03.72 0 7.84 0 7.84h2.66v-4.38c0-.23.02-.47.08-.63.19-.47.62-.96 1.34-.96.95 0 1.33.72 1.33 1.78v4.19h2.33z"
        />
      </svg>
    }
    @case ('email') {
      <svg class="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="1.8" aria-hidden="true">
        <path stroke-linecap="round" stroke-linejoin="round" d="M3.75 6.75h16.5v10.5A1.5 1.5 0 0118.75 18.75H5.25A1.5 1.5 0 013.75 17.25V6.75zm0 0L12 12.75 20.25 6.75" />
      </svg>
    }
  }

  @if (showLabel && label) {
    <span class="text-sm font-medium">{{ label }}</span>
  }
</a>
